import React from 'react';
import { MapPin, Video, TreePine } from 'lucide-react';

const CoachingRegionalInfo = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Flexibel vor Ort
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Finanzcoaching in Bayern & Remote
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Professionelles Finanzcoaching in der Metropolregion Nürnberg und ganz Bayern. 
            Befähigung zu eigenständigen Finanzentscheidungen vor Ort oder deutschlandweit per Remote-Coaching.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-soft hover:shadow-elevation transition-all duration-300 animate-fade-in" style={{ animationDelay: '0ms' }}>
            <div className="flex flex-col items-center text-center">
              <div className="h-12 w-12 bg-primary/10 rounded-full flex items-center justify-center text-primary shadow-sm mb-4">
                <MapPin className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Präsenz-Coaching Bayern</h3>
              <p className="text-joerg-600 mb-4">
                Geld-Coaching und Begleitung zum finanziellen Selbstentscheider in der Metropolregion Nürnberg, München, Ingolstadt, Regensburg und Umgebung.
              </p>
              <div className="text-sm text-joerg-500 space-y-1">
                <p>• Service-Radius: 140km um Roth (inkl. München)</p>
                <p>• Flexible Terminvereinbarung</p>
                <p>• Vor Ort in Ihren Räumen oder neutral</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-2xl shadow-soft hover:shadow-elevation transition-all duration-300 animate-fade-in" style={{ animationDelay: '150ms' }}>
            <div className="flex flex-col items-center text-center">
              <div className="h-12 w-12 bg-primary/10 rounded-full flex items-center justify-center text-primary shadow-sm mb-4">
                <Video className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Remote-Coaching Deutschland</h3>
              <p className="text-joerg-600 mb-4">
                Deutschlandweites Finanzcoaching per Videocall. Gleiche Qualität, maximale Flexibilität.
              </p>
              <div className="text-sm text-joerg-500 space-y-1">
                <p>• DSGVO-konforme Plattformen</p>
                <p>• Terminbuchung online</p>
                <p>• Digitale Unterlagen verfügbar</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-2xl shadow-soft hover:shadow-elevation transition-all duration-300 animate-fade-in" style={{ animationDelay: '300ms' }}>
            <div className="flex flex-col items-center text-center">
              <div className="h-12 w-12 bg-primary/10 rounded-full flex items-center justify-center text-primary shadow-sm mb-4">
                <TreePine className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Outdoor-Coaching Rothsee</h3>
              <p className="text-joerg-600 mb-4">
                Walk & Talk Coaching am Rothsee bei Hilpoltstein. Finanzthemen in der Natur besprechen.
              </p>
              <div className="text-sm text-joerg-500 space-y-1">
                <p>• Ganzjährig verfügbar</p>
                <p>• Neue Perspektiven durch Bewegung</p>
                <p>• <a href="/outdoor-coaching" className="text-primary hover:text-primary-600 underline">Mehr erfahren</a></p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-soft">
            <MapPin className="h-4 w-4 text-primary" />
            <span className="text-sm text-joerg-600">
              Hauptstandort: Roth (Mittelfranken) • Service: Bayern + Remote
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoachingRegionalInfo;